export default __webpack_public_path__ + "static/media/b-11.86e96a7a.png";